const filters = [
  {
    title: '需求类型',
    id: '1',
    children: [
      {
        text: '营销制定',
        value: '1',
        type: 'markFormula',
        orderTo: 'requireFilter'
      }
    ]
  },
  {
    title: '招标类型',
    id: '2',
    children: [
      {
        text: '公开招标',
        value: '2',
        type: 'openTender',
        orderTo: 'BiddingFilter'
      },
      {
        text: '定向招标',
        value: '3',
        type: 'orientTender',
        orderTo: 'BiddingFilter'
      }
    ]
  },
  {
    title: '排序类型',
    id: '3',
    children: [
      {
        text: '发布时间',
        value: 'createTime',
        type: 'publishT',
        orderTo: 'sortFilter'
      },
      {
        text: '截止时间',
        value: 'deadlineDate',
        type: 'deadlineT',
        orderTo: 'sortFilter'
      }
    ]
  },
]

const steps = [
  {
    text: '发布需求',
    index: '1',
    id: '0',
  },{
    text: '服务商报名',
    index: '2',
    id: '1',
  },{
    text: '选择服务商',
    index: '3',
    id: '2',
  },{
    text: '费用支付',
    index: '4',
    id: '3',
  },{
    text: '需求交付',
    index: '5',
    id: '4',
  },{
    text: '需求验收',
    index: '6',
    id: '5',
  },{
    text: '完成',
    index: '7',
    id: '6',
  },
]

const customizedTypeOpt = [
  {
    label: '公开招标',
    value: '2',
  },
  {
    label: '定向邀标',
    value: '3',
  },
]

const customizedType4label = {
  '3': '定向招标',
  '2': '公开招标'
}

const categoryThirCodeOpt = [
  {
    label: '营销定制',
    value: 'R9019522',
  },
  // {
  //   label: '数据服务',
  //   value: '3',
  // },
  // {
  //   label: '履约服务',
  //   value: '4',
  // },
  // {
  //   label: '商户服务',
  //   value: '5',
  // },
  // {
  //   label: '流量经营',
  //   value: '6',
  // },
]

const requireTypeCode4Label = {
  'R9019522': '营销定制'
}

const applyNumberOpt = [
  {
    label: '3家',
    value: '3'
  },
  {
    label: '5家',
    value: '5'
  },
  {
    label: '8家',
    value: '8'
  },
  {
    label: '不限',
    value: '0'
  },
]


/**
 * accountType: 需求方商户类型，1：品牌商，2：事业部,
 * signatureSign: 加签标识，1：需要加签，0：不需要加签,
 * maxBudget: 最大金额
*/
function setbtnState411(accountType, signatureSign, maxBudget, applyedCount) {
  if(['1','2'].includes(accountType) && Number(maxBudget) < 100000 && signatureSign == '0') {
    this.btnStatus.confirm = true;
    this.btnStatus.cancel = true;
  } else if(accountType == '2' && signatureSign == '1') {
    this.btnStatus.score = true;
    this.btnStatus.cancel = true;
  } else if(accountType == '2' && Number(maxBudget) > 100000 && applyedCount < 3) {
    this.btnStatus.republish = true;
    this.btnStatus.cancel = true;
  }
}

/**
 * accountType: 需求方商户类型，1：品牌商，2：事业部,
 * signatureSign: 加签标识，1：需要加签，0：不需要加签,
 * maxBudget: 最大金额
*/
function operatStatus({state, accountType, signatureSign, maxBudget, alreadyApplyNumber}) {
  const btnStatus = {
    ing: false,
    cancel: false,
    canceled: false,
    confirm: false,
    score: false,
    republish: false,
    selecting: false,
    done: false,
  }
  console.log(state);
  switch (state) {
    case '10':
      btnStatus.ing = true;
      btnStatus.cancel = true;
      break;
    case '13':
      btnStatus.canceled = true;
      break;
    case '11':
      if( accountType == '1' || (accountType == '2' && Number(maxBudget) < 100000 && signatureSign == '0')) {
        btnStatus.confirm = true;
        btnStatus.cancel = true;
      } else if(accountType == '2' && Number(maxBudget) >= 100000 && alreadyApplyNumber < 3) {
        btnStatus.republish = true;
        btnStatus.cancel = true;
      } else if(accountType == '2' && signatureSign == '1') {
        btnStatus.score = true;
        btnStatus.cancel = true;
      }
      break;
    case '14':
      if(accountType == '2' && signatureSign == '1') {
        btnStatus.selecting = true;
      }
      break;
    case '12':
      btnStatus.confirm = true;
      btnStatus.cancel = true;
      break;
    case '1':
      btnStatus.done = true;
      break;
    default:
      break;
  }
  console.log(btnStatus, 'btnStatus')
  return btnStatus;
}

export {
  filters,
  steps,
  customizedTypeOpt,
  categoryThirCodeOpt,
  applyNumberOpt,
  operatStatus,
  requireTypeCode4Label,
  customizedType4label
}